export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./foot.vue?vue&type=template&id=2c872504&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/foot.vue?vue&type=template&id=2c872504&scoped=true&
// module id = null
// module chunks = 